import React from 'react';
import CustomMasonry from 'js/wrapper/CustomMasonry';
import Lightbox from 'yet-another-react-lightbox';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';
import { find as _find } from 'lodash';

import { dispatchResizeEvent } from 'helpers/window';

import AbstractCmsElement from 'components/cms/elements/AbstractCmsElementNew';

export default class CmsElementGallery extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showLightbox: false,
      lightboxIndex: 0,
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  showLightbox = (lightboxIndex = 0) => {
    this.setState({ showLightbox: true, lightboxIndex });
  };

  closeLightbox = () => {
    this.setState({ showLightbox: false });
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { children } = this.props;

    if (children === null || prevProps.children === null || children.length !== prevProps.children.length) {
      dispatchResizeEvent();
    }

    this.__componentDidUpdate(prevProps, prevState);
  };

  getImageUrlFromParams = params => {
    const param = _find(params, ['name', 'imageUrl']);
    if (param) {
      return param.value;
    }

    return '';
  };

  render() {
    const { showLightbox, lightboxIndex, shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';

    const slides = this.props.children?.map(child => {
      return { src: this.getImageUrlFromParams(child.props.params) };
    });

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <div
        id={this.getMainId()}
        className={
          'ms-gallery-container ' +
          shownClass +
          this.getResponsiveClasses() +
          (this.getParamValue('isCondensed', 'no') === 'yes' ? ' condensed' : '') +
          this.getCssClasses()
        }
        style={{
          ...this.getBackgroundStyle(),
        }}
      >
        {this.getElementStyle()}

        <CustomMasonry
          className="ms-gallery"
          columns={{ default: 3, 1200: 3, 768: 2, 480: 1 }}
          gap="15px"
        >
          {this.props.children?.map((child, i) => {
            return React.cloneElement(child, { lightboxIndex: i, showLightbox: this.showLightbox });
          })}
        </CustomMasonry>

        <Lightbox
          open={showLightbox}
          index={lightboxIndex}
          close={this.closeLightbox}
          slides={slides}
          on={{
            view: ({ index }) => this.setState({ lightboxIndex: index })
          }}
        />

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementGallery.defaultProps = {
  index: '0',
};
